export enum APIErrorsMessage {
	ALREADY_EXISTS = 'Você já possui cadastro. Caso não lembre a sua senha, utilize a opção esqueci a senha.',
	NOT_FOUND = 'Não foi encontrado um beneficiário cadastrado com o cpf informado.',
	INVALID_INPUT = 'Dado inválido. Caso tenha digitado corretamente, entre em contato.',
	INVALID_BIRTHDAY = 'Não encontramos nenhum contrato vinculado a este CPF',
	INVALID_EMAIL = 'Verifique se digitou o e-mail corretamente, lembrando que o mesmo não pode ter sido utilizado como acesso em outro contrato.',
	INVALID_LOGIN_OR_PASSWORD = 'Login ou senha inválidos! Verifique as informações digitadas.',
	ALREADY_EXISTS_CONFIRM_REGISTER = 'Já existe um cadastro ativo para esse contrato, caso não lembre da senha, clique aqui para redefinir',
	INVALID_TOKEN = 'Token inválido.',
	EXPIRED_TOKEN = 'Token expirado.',
	NOT_ALLOWED_FOR_SPECIALTY = 'NotAllowedForSpecialty.',
}
